import { render, staticRenderFns } from "./LeaveHistoryBlock.vue?vue&type=template&id=3dc8375e&scoped=true&"
import script from "./LeaveHistoryBlock.vue?vue&type=script&lang=js&"
export * from "./LeaveHistoryBlock.vue?vue&type=script&lang=js&"
import style0 from "./LeaveHistoryBlock.vue?vue&type=style&index=0&id=3dc8375e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc8375e",
  null
  
)

export default component.exports